import {Routes} from '@angular/router';
import {ContactComponent} from "./pages/contact/contact.component";
import {HomeComponent} from "./pages/home/home.component";
import {SeoDto} from "./contracts/seo.dto";
import {AboutComponent} from './pages/about/about.component';
import {CareersComponent} from './pages/careers/careers.component';
import {CultureComponent} from './pages/culture/culture.component';
import {LegalComponent} from './pages/legal/legal.component';
import {UrlUtil} from "./utils/url.util";
import {PressReleasePageComponent} from './pages/press-release-page/press-release-page.component';
import {NewsComponent} from "./pages/news/news.component";
import {EventsComponent} from "./pages/events/events.component";
import {LoginComponent} from "./pages/auth/login.component";
import {LoginGuard} from './guards/login.guard';
import {NotFoundComponent} from './pages/not-found/not-found.cmp';
import {ApplyJob} from "./pages/apply-job/apply-job";
import {EnBtwAcademy} from "./pages/btw-academy/en-btw-academy";
import {RoBtwAcademy} from "./pages/btw-academy/ro-btw-academy";
import {DeBtwAcademy} from "./pages/btw-academy/de-btw-academy";
import {EnClusterEngineering} from "./pages/cluster-engineering/en-cluster-engineering";
import {HiddenMapComponent} from "./pages/hidden-map/hidden-map.cmp";

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'en',
    pathMatch: 'full'
  },
  {
    path: ':lang',
    component: HomeComponent,
    data: {
      seo: {
        title: 'BMW Group TechWorks Romania',
        description: 'BMW Group TechWorks Romania leads automotive innovation in partnership with the BMW Group, shaping the future of motion',
        ogUrl: UrlUtil.composeUrlRoute(''),
        url: UrlUtil.composeUrlRoute(''),
        ogImage: UrlUtil.composeUrlRoute('/images/homepage.webp')
      } as SeoDto
    }
  },

  {
    path: 'login',
    redirectTo: 'en/login',
    pathMatch: 'full'
  },
  {
    path: ':lang/login',
    canActivate: [LoginGuard],
    component: LoginComponent
  },

  {
    path: 'careers',
    redirectTo: 'en/careers',
    pathMatch: 'full'
  },
  {
    path: ':lang/careers',
    component: CareersComponent,
    data: {
      seo: {
        title: 'Careers',
        description: 'Browse all our available job openings',
        ogUrl: UrlUtil.composeUrlRoute('careers'),
        url: UrlUtil.composeUrlRoute('careers'),
        ogImage: UrlUtil.composeUrlRoute('images/careers-page.webp')
      } as SeoDto
    }
  },

  {
    path: ':lang/culture',
    component: CultureComponent,
    data: {
      seo: {
        title: 'Our Culture and Values ',
        description: 'Discover our opportunities and  take the next career step with BMW TechWorks Romania',
        ogUrl: UrlUtil.composeUrlRoute('culture'),
        url: UrlUtil.composeUrlRoute('culture'),
        ogImage: UrlUtil.composeUrlRoute('images/culture-page.webp')
      } as SeoDto
    }
  },

  {
    path: 'btw-academy',
    redirectTo: 'en/btw-academy',
    pathMatch: 'full'
  }, {
    path: 'en/btw-academy',
    component: EnBtwAcademy,
    data: {
      seo: {
        title: 'BMW TechWorks Academy',
        description: 'BMW TechWorks Romania Academy is the educational and development platform of BMW TechWorks Romania, created to connect the academic world with the real-world challenges of technology and innovation.',
        ogUrl: UrlUtil.composeUrlRoute('btw-academy'),
        url: UrlUtil.composeUrlRoute('btw-academy'),
        ogImage: UrlUtil.composeUrlRoute('btw-academy/website-headers_desktop.jpg')
      } as SeoDto
    }
  }, {
    path: 'de/btw-academy',
    component: DeBtwAcademy,
    data: {
      seo: {
        title: 'BMW TechWorks Academy',
        description: 'Die BMW TechWorks Romania Academy ist die Bildungs- und Entwicklungsplattform von BMW TechWorks Romania, die geschaffen wurde, um eine starke Verbindung zwischen der akademischen Welt und der realen Technologiewelt herzustellen.',
        ogUrl: UrlUtil.composeUrlRoute('btw-academy'),
        url: UrlUtil.composeUrlRoute('btw-academy'),
        ogImage: UrlUtil.composeUrlRoute('btw-academy/website-headers_desktop.jpg')
      } as SeoDto
    }
  }, {
    path: 'ro/btw-academy',
    component: RoBtwAcademy,
    data: {
      seo: {
        title: 'BMW TechWorks Academy',
        description: 'BMW TechWorks România Academy este platforma educațională și de dezvoltare a BMW TechWorks România, creată pentru a construi o punte solidă între mediul academic și industria tehnologică globală.',
        ogUrl: UrlUtil.composeUrlRoute('btw-academy'),
        url: UrlUtil.composeUrlRoute('btw-academy'),
        ogImage: UrlUtil.composeUrlRoute('btw-academy/website-headers_desktop.jpg')
      } as SeoDto
    }
  },
  {
    path: 'cluster-engineering',
    redirectTo: 'en/cluster-engineering',
    pathMatch: 'full'
  }, {
    path: 'en/cluster-engineering',
    component: EnClusterEngineering,
    data: {
      seo: {
        title: 'Cluster Engineering',
        description: 'Cluster Engineering in BMW Techworks Romania plays a key role in shaping how BMW turns ideas into real products.',
        ogUrl: UrlUtil.composeUrlRoute('cluster-engineering'),
        url: UrlUtil.composeUrlRoute('cluster-engineering'),
        ogImage: UrlUtil.composeUrlRoute('btw-academy/website-headers_desktop.jpg')
      } as SeoDto
    }
  }, {
    path: 'de/cluster-engineering',
    component: EnClusterEngineering,
    data: {
      seo: {
        title: 'Cluster Engineering',
        description: 'Cluster Engineering in BMW Techworks Romania plays a key role in shaping how BMW turns ideas into real products.',
        ogUrl: UrlUtil.composeUrlRoute('cluster-engineering'),
        url: UrlUtil.composeUrlRoute('cluster-engineering'),
        ogImage: UrlUtil.composeUrlRoute('cluster-engineering/website-headers_desktop.jpg')
      } as SeoDto
    }
  }, {
    path: 'ro/cluster-engineering',
    component: EnClusterEngineering,
    data: {
      seo: {
        title: 'Cluster Engineering',
        description: 'Cluster Engineering in BMW Techworks Romania plays a key role in shaping how BMW turns ideas into real products.',
        ogUrl: UrlUtil.composeUrlRoute('cluster-engineering'),
        url: UrlUtil.composeUrlRoute('cluster-engineering'),
        ogImage: UrlUtil.composeUrlRoute('cluster-engineering/website-headers_desktop.jpg')
      } as SeoDto
    }
  },
  {
    path: 'legal',
    redirectTo: 'en/legal',
    pathMatch: 'full'
  },
  {
    path: ':lang/legal',
    component: LegalComponent,
    data: {
      seo: {
        title: 'Legal information',
        description: 'Legal information',
      } as SeoDto
    }
  },

  {
    path: 'press',
    redirectTo: 'en/press',
    pathMatch: 'full'
  },
  {
    path: ':lang/press',
    component: PressReleasePageComponent,
    data: {
      seo: {
        title: 'Press Release Page',
        description: 'Press Release Page Desc',
      } as SeoDto
    }
  },


  {
    path: 'news',
    redirectTo: 'en/news',
    pathMatch: 'full'
  },
  {
    path: ':lang/news',
    component: NewsComponent,
    data: {
      seo: {
        title: 'BMW Group TechWorks Romania - News',
        description: 'Read new stories about the company and learn more about current technological trends and innovations',
        ogUrl: UrlUtil.composeUrlRoute('news'),
        url: UrlUtil.composeUrlRoute('news'),
        ogImage: UrlUtil.composeUrlRoute('images/news-page.webp')
      } as SeoDto
    }
  },

  {
    path: 'events',
    redirectTo: 'en/events',
    pathMatch: 'full',
  },
  {
    path: ':lang/events',
    component: EventsComponent,
    data: {
      seo: {
        title: 'BMW Group TechWorks Romania - Events',
        description: 'Read new events about the company and learn more about current technological trends and innovations',
        ogUrl: UrlUtil.composeUrlRoute('news'),
        url: UrlUtil.composeUrlRoute('news'),
        ogImage: UrlUtil.composeUrlRoute('images/news-page.webp')
      } as SeoDto
    },
  },

  {
    path: 'contact',
    redirectTo: 'en/contact',
    pathMatch: 'full'
  },
  {
    path: ':lang/contact',
    component: ContactComponent,
    data: {
      seo: {
        title: 'Contact Us',
        description: '',
        ogUrl: UrlUtil.composeUrlRoute('contact'),
        url: UrlUtil.composeUrlRoute('contact'),
        ogImage: UrlUtil.composeUrlRoute('images/contact-page.webp')
      } as SeoDto
    }
  },

  {
    path: 'about',
    redirectTo: 'en/about',
    pathMatch: 'full'
  },
  {
    path: ':lang/about',
    component: AboutComponent,
    data: {
      seo: {
        title: 'About Us',
        description: 'Introducing BMW Group TechWorks Romania, the European IT hub of BMW',
        ogUrl: UrlUtil.composeUrlRoute('about'),
        url: UrlUtil.composeUrlRoute('about'),
        ogImage: UrlUtil.composeUrlRoute('images/about-page.webp')
      } as SeoDto
    }
  },

  {
    path: 'drop-cv',
    redirectTo: 'en/drop-cv',
    pathMatch: 'full'
  },
  {
    path: 'ro/drop-cv',
    component: ApplyJob,
    data: {
      seo: {
        title: 'Incarca cv',
        description: 'Aplica pentru un job aici',
        ogUrl: UrlUtil.composeUrlRoute('drop-cv'),
        url: UrlUtil.composeUrlRoute('drop-cv'),
        ogImage: UrlUtil.composeUrlRoute('images/about-page.webp')
      } as SeoDto
    }
  }, {
    path: 'de/drop-cv',
    component: ApplyJob,
    data: {
      seo: {
        title: 'Lebenslauf hier ablegen',
        description: 'Hier für eine Stelle bewerben',
        ogUrl: UrlUtil.composeUrlRoute('drop-cv'),
        url: UrlUtil.composeUrlRoute('drop-cv'),
        ogImage: UrlUtil.composeUrlRoute('images/about-page.webp')
      } as SeoDto
    }
  }, {
    path: 'en/drop-cv',
    component: ApplyJob,
    data: {
      seo: {
        title: 'Drop cv',
        description: 'Apply for a job here',
        ogUrl: UrlUtil.composeUrlRoute('drop-cv'),
        url: UrlUtil.composeUrlRoute('drop-cv'),
        ogImage: UrlUtil.composeUrlRoute('images/about-page.webp')
      } as SeoDto
    }
  },
  {
    path: 'hidden-map',
    redirectTo: 'en/hidden-map',
    pathMatch: 'full'
  },{
    path: 'de/hidden-map',
    component: HiddenMapComponent
  },{
    path: 'ro/hidden-map',
    component: HiddenMapComponent
  },{
    path: 'en/hidden-map',
    component: HiddenMapComponent
  },

  {path: '', loadChildren: () => import('./pages/about/routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/contact/routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/visitors/routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/news-detail/news-detail.routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/events/details/event-details.routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/privacy-policy/routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/privacy-policy/whistle-blower/routes').then(m => m.routes)},
  {path: '', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule)},

  {path: '**', component: NotFoundComponent}
];
